export default "/_next/static/media/news-author-02.ef037dd135aa0098d1334ac420ac89a0.jpg";